/**
 * @file
 */

import { customValidationInit } from "@/common/validation/init.js";

var saveChanges = false;

export function InitializeScheduleCallPage() {
   // --------------------------------------------------------------------------
   // initialize the validation engine
   // --------------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);

   // --------------------------------------------------------------------------
   // create a 2D array from the code behind array contactTimeArray
   // The first column is the times that appear in the drop down (i.e. "2:00 PM").  The second column is used 
   // to determine if the time of the first column should be display and whether it should be disabled or not.  
   // Values for the second column include:
   //     Y = time should be in the list and enabled
   //     N = time should not be in the list
   //     D = time should be in the list but disabled
   //     F = time should be in the list but disabled due to corresponding date is a friday
   // --------------------------------------------------------------------------
   var contactTimes = [];
   var index;
   var index1 = 0;
   var tempRow;
   for (index = 0; index < 24; index++) {
      tempRow = [contactTimeArray[index1], contactTimeArray[index1 + 1]];
      contactTimes.push(tempRow);
      index1 = index1 + 2;
   }

   // --------------------------------------------------------------------------
   // define click-change event for the calendar
   // --------------------------------------------------------------------------
   $("[id$='txtCommonCalendarDate']").change(function () {
      // get today and tomorrow's date
      var today = new Date();
      var tommorrow = new Date();
      tommorrow.setDate(tommorrow.getDate() + 1);
      // get the selected date (calendar dropdown)
      var selectedDateText = $("[id$='txtCommonCalendarDate']").val();

      // check if the selectedDateText is populated.  Only proceed if there is a value
      if (selectedDateText == "") {
         return
      }

      var selectedDate = new Date(selectedDateText);
      var dayOfTheWeek = selectedDate.getDay();
      var $contactTimeList = $("select[id$='ddlContactTime']");
      var needToUpdateDropdown = "N";


      // handle 24 hour limit
      // only relevant if selected date is tomorrow and it is currently before 4pm.
      if (selectedDate.toLocaleDateString() == tommorrow.toLocaleDateString()) {
         if (today.getHours() < 16) {
            var i;
            for (i = 0; i <= today.getHours() ; i++) {
               // disable the time if it is currently enabled
               if (contactTimes[i][1] == "Y") {
                  contactTimes[i][1] = "D"
                  needToUpdateDropdown = "Y";
               }
            }
         }
      }
         // selected date is not tomorrow so reset the table entries with 'D' (disabled)
         // to be 'Y' (enabled)
      else {
         var i;
         for (i = 0; i < contactTimes.length; i++) {
            if (contactTimes[i][1] == "D") {
               contactTimes[i][1] = "Y";
               needToUpdateDropdown = "Y";
            }
         }
      }
      // if selected date is Friday then we need to disable 5:00, 6:00, and 7:00 PM time slots
      if (dayOfTheWeek == 5) {
         contactTimes[17][1] = "F";
         contactTimes[18][1] = "F";
         contactTimes[19][1] = "F";
         needToUpdateDropdown = "Y";
      }
         // selected date is not friday so reset the table entries with 'F' (disabled - friday)
         // to be 'Y' (enabled).  Only set the need to update flag if a change needs to occur.
      else {
         if (contactTimes[17][1] = "F")
            needToUpdateDropdown = "Y";
         contactTimes[17][1] = "Y";
         contactTimes[18][1] = "Y";
         contactTimes[19][1] = "Y";
      }

      // now perform the actual drop down adjustments
      if (needToUpdateDropdown == "Y") {
         var i;

         // change selected to be default 'select time'
         $contactTimeList.val("");

         // loop through the contact Times and disable or enable as appropriate
         for (i = 0; i < contactTimes.length; i++) {
            // if time should be displayed but is currently disabled then remove the disabled attribute              
            if ((contactTimes[i][1] == "Y") &&
               $contactTimeList.find('option[value="' + contactTimes[i][0] + '"]:disabled')) {
               $contactTimeList.find('option[value="' + contactTimes[i][0] + '"]').removeAttr('disabled');
            }
               // if the time should be disabled but is currently enabled or if the time is listed as
               // "F" for "Friday" then add the disabled attribute
            else if (((contactTimes[i][1] == "D") &&
               $contactTimeList.find('option[value="' + contactTimes[i][0] + '"]:enabled')) ||
               (contactTimes[i][1] == "F")) {
               $contactTimeList.find('option[value="' + contactTimes[i][0] + '"]').attr('disabled', 'disabled');
            }
         }
      }
   });

   // --------------------------------------------------------------------------
   // define input mask for the phone
   // --------------------------------------------------------------------------
   $("[id$='txtPhone']").mask("?(999) 999-9999");


   // --------------------------------------------------------------------------
   // review dialog box
   // --------------------------------------------------------------------------
   $("#divScheduleCallDialog").dialog({
      modal: true,
      autoOpen: false,
      title: "Schedule My Call",
      width: 560,
      buttons: [
         {
            text: "Schedule My Call",
            class: "primary",
            click: function () {
               saveChanges = true;
               $("[id$='btnScheduleCallSubmit']").click();
            }
         },
         {
            text: "Cancel",
            class: "secondary",
            click: function () {
               $(this).dialog("close");
            }
         }
      ]
   });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.updateTextAndDisplayDialog = updateTextAndDisplayDialog;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.handleScheduleClick = handleScheduleClick;
};

function updateTextAndDisplayDialog() {
   var callPhone = $("[id$='txtPhone']").val();
   var callTime = $("[id$='ddlContactTime']").val();
   var callDate = $("[id$='txtCommonCalendarDate']").val();
   var callDetails = $("p.callDetails");
   var callDetailsText = callDetails[0].innerText;

   callDetailsText = callDetailsText.replace("[time]", callTime).replace("[date]", callDate).replace("[phone]", callPhone);
   callDetails[0].innerText = callDetailsText;

   $("#divScheduleCallDialog").dialog("open");
}

function handleScheduleClick() {
   if (saveChanges) {
      return true;
   } else {
      updateTextAndDisplayDialog();
      return false;
   }
}
